/**
 * Created by koqiui on 2017-04-09.
 */
import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';
//
import ContractVoucherSendMsgList from './ContractVoucherSendMsgList';
import SendMsg from './SendMsg.vue';
import merchtAllApi from '../../api/merchtAll';
import SendMsgMail from './SendMsgMail';
Vue.regist(ContractVoucherSendMsgList);

export function openSendMsgListDlg(source, group, fieldx, fieldy, receiverType, contractId) {
    //
    Vue.$showDialog({
        title: '站内信',
        showCloseBtn: true,
        width: '70%',
        height: 600,
        okVisible: false,
        cancelText: '关闭',
        template: '<div>' +
        '<swb-contract-voucher-send-msg-list :source="source" :group = "group" :fieldx = "fieldx" :fieldy = "fieldy" :receiverType = "receiverType" :contractId = "contractId" ref="swb_send_msg_list"></swb-contract-voucher-send-msg-list>' +
        '</div>',
        data: {
            source: source,
            group: group,
            fieldx: fieldx,
            fieldy: fieldy,
            receiverType: receiverType,
            contractId: contractId
        },
        methods: {},
        okClicked: function () {
        },
    });
}

Vue.regist(SendMsg);
export function showMsgSendDlg(dlgArgs, callback, thisArg) {
    dlgArgs = dlgArgs || {};
    callback = callback || null;
    thisArg = thisArg || null;
    //
    let dlgTitle = dlgArgs['dlgTitle'] || '发送站内信';
    let targetType = dlgArgs['targetType'] || null;
    //
    let theDlg = Vue.$showDialog({
        title: dlgTitle,
        showCloseBtn: true,
        width: 1000,
        height: 600,
        template: '<div>\
                        <swb-send-msg ref="swb_send_msg" :targetType="targetType"></swb-send-msg>\
                   </div>\
        ',
        data: {
            targetType: targetType
        },
        methods: {},
        okClicked: function () {
            let resultData = this.$refs.swb_send_msg.getResultData() || {};
            if(resultData.msgInfo == null) {
                Toast.show('请填写站内信信息', 3000, 'warning');
                return false;
            }
            if(targetType == 'staff') {
                let staffIds = resultData.staffIds;
                if(staffIds == null || staffIds.length < 1) {
                    Toast.show('请选择接收人员', 3000, 'warning');
                    return false;
                }
            }
            //
            if(typeof callback == 'function') {
                callback.apply(thisArg, [resultData]);
            }
        },
    });
}

export function showContractVoucherMsgSendDlg(dlgArgs, callback, thisArg) {
    dlgArgs = dlgArgs || {};
    callback = callback || null;
    thisArg = thisArg || null;
    //
    let dlgTitle = dlgArgs['dlgTitle'] || '发送站内信';
    let targetType = dlgArgs['targetType'] || null;
    //
    let theDlg = Vue.$showDialog({
        title: dlgTitle,
        showCloseBtn: true,
        width: 1000,
        height: 600,
        template: '<div>\
                        <div style = "margin-left: 150px;margin-bottom: 20px;">\
                            <el-radio class="radio" v-model="msgIsSend" :label="false">内部</el-radio>\
                            <el-radio class="radio" v-model="msgIsSend" :label="true">对方</el-radio>\
                        </div>\
                        <swb-send-msg ref="swb_send_msg" :targetType="targetType"></swb-send-msg>\
                   </div>\
        ',
        data: {
            targetType: targetType,
            msgIsSend: false
        },
        methods: {},
        okClicked: function () {
            let resultData = this.$refs.swb_send_msg.getResultData() || {};
            if(resultData.msgInfo == null) {
                Toast.show('请填写站内信信息', 3000, 'warning');
                return false;
            }
            if(targetType == 'staff') {
                let staffIds = resultData.staffIds;
                if(staffIds == null || staffIds.length < 1) {
                    Toast.show('请选择接收人员', 3000, 'warning');
                    return false;
                }
            }
            resultData.msgIsSend = this.msgIsSend;
            //
            if(typeof callback == 'function') {
                callback.apply(thisArg, [resultData]);
            }
        },
    });
}

// ------------ 通用组件 ------------------
Vue.regist(SendMsgMail);

/**
 *
 * @param isVoucher     -- 是否基于 单据类
 * @param voucherNo     -- 单据号
 * @param voucherType   -- 单据类型 --- resc/app/js/voucherType.js
 * @param receiverData [
 * * voucherChildType  -- 单据子类型  ps ： contract.getTypeId()
 * * currentPostIds       -- 内部岗位Ids信息
 * * currentMerchtType    -- 内部商户类型
 * * otherPostIds        -- 对外岗位Ids
 * * otherMerchtType        -- 对外商户类型
 * ]
 */
export function sendMsgMail(isVoucher, voucherNo, voucherType, receiverData) {
    isVoucher = isVoucher || false;
    voucherNo = voucherNo || null;
    voucherType = voucherType || null;
    let voucherChildType = null;
    let currentPostIds = null;
    let currentMerchtType = null;
    let otherPostIds = null;
    let otherMerchtType = null;
    if(!Utils.isNoB(receiverData) && isVoucher) {
        voucherChildType = receiverData.voucherChildType || null;
        currentPostIds = receiverData.currentPostIds || null;
        currentMerchtType = receiverData.currentMerchtType || null;
        otherPostIds = receiverData.otherPostIds || null;
        otherMerchtType = receiverData.otherMerchtType || null;
    }
    //
    if(isVoucher) {
        if(currentMerchtType == null) {
            Toast.show('未找到-当前商户类型', 3000, 'warning');
            return false;
        }
        if(voucherNo == null) {
            Toast.show('未找到-单据号信息', 3000, 'warning');
            return false;
        }
        if(voucherType == null) {
            Toast.show('未找到-单据类型信息', 3000, 'warning');
            return false;
        }
    }
    //
    let theDlg = Vue.$showDialog({
        title: "发送站内信",
        showCloseBtn: true,
        width: 1000,
        height: 600,
        template: '<swb-send-msg-mail :isVoucher="isVoucher" ref="swb_send_msg_mail"></swb-send-msg-mail>',
        data: {
            isVoucher: isVoucher,
        },
        methods: {},
        okClicked: function () {
            let resultData = this.$refs.swb_send_msg_mail.getResultData() || {};
            if(resultData.msgInfo == null) {
                Toast.show('请填写站内信信息', 3000, 'warning');
                return false;
            }
            if(!isVoucher) {
                let staffIds = resultData.staffIds;
                if(staffIds == null || staffIds.length < 1) {
                    Toast.show('请选择接收人员', 3000, 'warning');
                    return false;
                }
            }
            //
            if(isVoucher) {
                if(Utils.isNoB(currentPostIds) && resultData.comIn) {
                    Toast.show('未找到-内部接收的岗位信息', 3000, 'warning');
                    return false;
                }
                if(Utils.isNoB(otherMerchtType) && resultData.comOut) {
                    Toast.show('未找到-对方接收者商户类型', 3000, 'warning');
                    return false;
                }
                if(Utils.isNoB(otherPostIds) && resultData.comOut) {
                    Toast.show('未找到-对方接收的岗位信息', 3000, 'warning');
                    return false;
                }
            }
            //
            let postData = {};
            let msgInfo = resultData.msgInfo;
            postData.data = msgInfo.data;
            postData.txt = msgInfo.txt;
            //
            postData.isVoucher = isVoucher;
            if(isVoucher) {
                postData.comIn = resultData.comIn;
                postData.comOut = resultData.comOut;
                postData.voucherNo = voucherNo;
                postData.voucherType = voucherType;
                postData.voucherChildType = voucherChildType;
                postData.currentPostIds = currentPostIds;
                postData.currentMerchtType = currentMerchtType;
                postData.otherPostIds = otherPostIds;
                postData.otherMerchtType = otherMerchtType;
            } else {
                //
                postData.staffIds = resultData.staffIds;
            }
            //
            let theLoad = MsgBox.loading();
            merchtAllApi.sendSiteMsgMail(postData, function (result) {
                theLoad.hide();
                MsgBox.success("发送成功！");
            });
            //
        }
    });
}

import SwbVoucherMsgList from "./VoucherMsgList.vue";
Vue.regist(SwbVoucherMsgList);

export function openVoucherMsgListDlg(params) {
    let group = params['group'] || null;
    let fieldx = params['fieldx'] || null;
    let fieldy = params['fieldy'] || null;
    Vue.$showDialog({
        title: '站内信',
        showCloseBtn: true,
        width: '70%',
        height: 600,
        okVisible: false,
        cancelText: '关闭',
        template: '<div>' +
        '<swb-voucher-msg-list :source="source" :group = "group" :fieldx = "fieldx" :fieldy = "fieldy" :receiverType = "receiverType" ref="swb_voucher_msg_list"></swb-voucher-msg-list>' +
        '</div>',
        data: {
            group: group,
            fieldx: fieldx,
            fieldy: fieldy,
        },
        methods: {},
        okClicked: function () {
        },
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/msg/dialog.js
// module id = 362
// module chunks = 0